import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogResult } from '../../../models/modal-dialog-result';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-generic-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './generic-confirm-modal.component.html',
  styleUrl: './generic-confirm-modal.component.scss'
})
export class GenericConfirmModalComponent {
  @Input() title: string = 'Please confirm?';
  @Input() message: string = '';

  public onClose: Subject<DialogResult> = new Subject();

  constructor(public activeModal: NgbActiveModal) {
  }

  ok() {
    this.onClose.next({ result: true });
    this.activeModal.dismiss();
  }

  cancel() {
    this.onClose.next({ result: false });
    this.activeModal.dismiss();
  }
}
